import { z } from 'zod';
import { EntityNode, Confidence } from './entities.js';
import { CitationRef, Fact, SourceRef } from './ask.js';
import { GraphData } from './graph.js';
export const DossierNote = z.object({
    id: z.string(),
    entityName: z.string(),
    authorUid: z.string(),
    authorDisplayName: z.string().optional(),
    body: z.string(),
    createdAt: z.string(),
    updatedAt: z.string().optional(),
});
/**
 * A single labeled section of an AI-generated synthesis. Each section
 * has its own confidence score (frontend spec §5.4) and its own set
 * of citations pointing back into the structured graph + sources.
 */
export const SynthesisSection = z.object({
    heading: z.string(),
    body: z.string(),
    confidence: Confidence,
    citations: z.array(CitationRef).default([]),
});
export const Dossier = z.object({
    entity: EntityNode,
    synthesis: z
        .object({
        sections: z.array(SynthesisSection),
        generatedAt: z.string(),
        model: z.string(),
    })
        .optional(),
    facts: z.array(Fact),
    sources: z.array(SourceRef),
    network: GraphData,
});
